import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationPermissionService {
  constructor(
    public afs: AngularFirestore,
  ) { }
  listenForForegroundMessages(messaging) {
    onMessage(messaging, (payload) => {
      const { title = 'Notification', body = '', icon = '/assets/default-icon.png' } = payload.notification || {};
      new Notification(title, { body, icon });
    });
  }
  async requestPermission(storeName: string, storeUid: string, loggedIn: string) {
    try {
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        // console.log('Notification permission denied.');
        return;
      }

      const registration = await navigator.serviceWorker.ready;

      const messaging = getMessaging();
      this.listenForForegroundMessages(messaging);

      const currentToken = await this.generateToken(messaging, registration);
      if (!currentToken) return;

      this.handleTokenStorage(storeName, storeUid, loggedIn, currentToken);

    } catch (error) {
      console.error('Error in requestPermission:', error);
    }
  }

  async generateToken(messaging, registration: ServiceWorkerRegistration): Promise<string | null> {
    try {
      const token = await getToken(messaging, {
        vapidKey: environment.firebase.vapidKey,
        serviceWorkerRegistration: registration
      });
      if (!token) {
        return null;
      }

      return token;
    } catch (error) {
      console.error('Error retrieving token:', error);
      return null;
    }
  }

  handleTokenStorage(storeName: string, storeUid: string, loggedIn: string, currentToken: string) {
    const access_token = localStorage.getItem('access_token')
    const storeNameToken = localStorage.getItem('storeNameToken')
    const isLoggedIn = localStorage.getItem('isLoggedIn')
    const storeArray = JSON.parse(localStorage.getItem('storeArray'));
    const userRole: any = JSON.parse(localStorage.getItem('userrole') || 'null');
    const storeRole = localStorage.getItem('storeRole')
    const userRoleUid = localStorage.getItem('userRoleUid')

    // Check if token needs to be updated
    const needsUpdate = userRole !== null && userRole !== undefined
      ? (access_token != currentToken || storeNameToken != storeName || storeRole != userRole.role || 
         userRoleUid != userRole.uid || isLoggedIn != loggedIn || JSON.stringify(storeArray) != JSON.stringify(userRole.store))
      : (access_token != currentToken || storeNameToken != storeName);

    if (needsUpdate) {
      this.updateLocalStorage(storeName, currentToken, loggedIn, userRole);
      this.saveTokenToFirestore(storeName, storeUid, currentToken, loggedIn);
    }
  }

  // Helper method to update localStorage (reduces duplication)
  private updateLocalStorage(storeName: string, currentToken: string, loggedIn: string, userRole: any): void {
    localStorage.setItem('access_token', currentToken);
    localStorage.setItem('storeNameToken', storeName);
    localStorage.setItem("isLoggedIn", loggedIn);
    
    if (userRole !== null && userRole !== undefined) {
      localStorage.setItem("storeRole", userRole.role);
      localStorage.setItem("userRoleUid", userRole.uid);
      if (userRole?.store) {
        localStorage.setItem("storeArray", JSON.stringify(userRole.store));
      }
    }
  }
  async saveTokenToFirestore(storeName: string, storeUid: string, token: string, LoggedIn) {
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const userRole: any = JSON.parse(localStorage.getItem('userrole') || 'null');
    const userTokenDocId: any = localStorage.getItem('userTokenDocId');
    const userUid: any = localStorage.getItem('userTokenDocId');
    
    // Use helper method to build token data (reduces duplication)
    const tokenData = this.buildTokenData(token, storeName, storeUid, userTimeZone, LoggedIn, userRole, userUid);
    if (userTokenDocId) {
      const product_data = await this.afs.collection('userTokens').doc(userTokenDocId).get().toPromise();
      if (product_data?.exists) {
        // ✅ Update only the token field in the existing document
        await this.afs.collection('userTokens').doc(userTokenDocId).set(tokenData);
        // console.log(`Updated token in document`);
        return;
      }
    }
    const master_product_data = await this.afs.collection('userTokens').add(tokenData).then(async docRef => {
      localStorage.setItem('userTokenDocId', docRef.id);
      await this.afs.collection('userTokens').doc(docRef.id).update({ userUid: docRef.id });
      // console.log('FCM Token and Store Info successfully saved with auto-generated ID""""""""""""""!');
    }).catch((error) => {
      console.error('Error saving token to Firestore', error);
    });
  }

  // Helper method to build token data (reduces duplication)
  private buildTokenData(token: string, storeName: string, storeUid: string, timeZone: string, 
                         loggedIn: string, userRole: any, userUid: string): any {
    const baseTokenData = {
      token: token,
      storeName: storeName,
      storeUid: storeUid,
      link: window.location.origin,
      timeZone: timeZone,
      userUid: userUid ? userUid : ''
    };

    if (userRole !== null && userRole !== undefined) {
      if (userRole?.role == 'store-manager' || userRole?.role == 'admin-manager') {
        return {
          ...baseTokenData,
          isLoggedIn: loggedIn,
          userEmail: userRole?.email ? userRole?.email : '',
          userroleid: userRole?.uid ? userRole?.uid : '',
          store: userRole?.store ? userRole?.store : [],
          userRole: 'store-manager'
        };
      }
    }

    // Default customer token data
    return {
      ...baseTokenData,
      isLoggedIn: 'no',
      userEmail: '',
      userroleid: '',
      store: [],
      userRole: 'customer'
    };
  }
}
